import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {LocationState} from "@/interfaces/state/location";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {LocationParams} from "@/modules/location/params";
import store from "@/store"
import {Location} from "@/interfaces/entity";
import {deleteLocation, listLocation, singleLocation} from "@/modules/location/services";

@Module({dynamic: true, name: "location", store})
class LocationModule extends VuexModule implements LocationState {
    data: IdMapper<Location> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: LocationParams = new LocationParams();
    locationCreateLading: Location = {} as any;

    get locations() {
        return this.ids.map((id: number) => this.data[id]);
    }

    @Mutation
    private UPDATE_LOCATION_PARAMS(payload: any) {
        this.params = payload
    }

    @Mutation
    private MAP_LOCATION(payload: any) {
        const idMapper: IdMapper<Location> = {};
        this.meta = payload.meta;
        this.ids = payload.datas.map((location: Location) => {
            idMapper[location.id!] = {...location, isDeleting: false};
            return location.id;
        })
        this.data = idMapper;
    }

    @Mutation
    private UPDATE_LOCATION(payload: Location) {
        if (!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.data[payload.id] = {...payload, isDeleting: false}
    }

    @Mutation
    private DELETE_LOCATION(payload: any) {
        this.ids = this.ids.filter((id: number) => id !== payload);
        delete this.data[payload]
    }

    @Mutation
    private START_DELETE_LOCATION(id: number) {
        this.data[id].isDeleting = true;
    }

    @Mutation
    private END_DELETE_LOCATION(id: number) {
        this.data[id].isDeleting = false;
    }

    @Mutation
    private UPDATE_LOCATION_CREATE_LADING(payload: any) {
        this.locationCreateLading = payload
    }

    @Action({ rawError: true })
    public updateLocationCreateLading(payload: any) {
        this.UPDATE_LOCATION_CREATE_LADING(payload);
    }

    @Action({ rawError: true })
    public updateLocationParams(payload: any) {
        this.UPDATE_LOCATION_PARAMS(payload);
    }

    @Action({rawError: true})
    public async listLocation(params: LocationParams = new LocationParams()) {
        const {data} = await listLocation(params)
        this.MAP_LOCATION(data);
    }

    @Action({rawError: true})
    public async singleLocation(id: number) {
        const {data} = await singleLocation(id);
        return data.data;
    }

    @Action({rawError: true})
    public async deleteLocation(payload: any) {
        await deleteLocation(payload)
        this.DELETE_LOCATION(payload)
    }

}

export const LocationStore = getModule(LocationModule)
